import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  // Changelog entries. Newest entries must be placed at the top.
  changelog: { version: string; date: string; changes: string[] }[] = [
    {
      version: '2.6.17',
      date: '17.07.2026',
      changes: ['Updated node version.']
    },
    {
      version: '2.6.16',
      date: '07.07.2026',
      changes: ['Changed configuration of container app to use a new image for the excel calculator backend.']
    },
    {
      version: '2.6.15',
      date: '22.06.2026',
      changes: ['Fixed display at Total Price in Target Currency']
    },
    {
      version: '2.6.14',
      date: '19.06.2026',
      changes: [
        'Project Assignment now supports multiple users',
        'Fixed dislay error for PCS neo prev cost when PCS neo is not selected',
        'Fixed display error at IADC Cost Overview in Backup & Restore Section'
      ]
    },
    {
      version: '2.6.13',
      date: '17.06.2026',
      changes: ['Help texts now support clickable links.', 'Added a changelog section on the start page.']
    }
  ];

  constructor() {}
}
